module.exports = __webpack_public_path__ + "static/media/property-managers-card-icon.71b593da.svg";